import axios from "axios";
import firebase from "firebase";

const shiftsApiService = {
  async get(startDate, endDate) {
    const userIdToken = await firebase.auth().currentUser.getIdToken(true);
    const endpoint = `/api/shifts?start_date=${startDate}&end_date=${endDate}`;

    return new Promise((resolve, reject) => {
      axios.get(endpoint, { headers: { "Authorization": userIdToken } })
        .then(response => resolve(response.data.shifts))
        .catch(reason => reject(new Error("Shifts API Error. " + reason.message)));
    });
  },

  getShiftCount(startDate, endDate) {
    return this.get(startDate, endDate).then(shifts => {
      return shifts.length;
    });
  },

  getShiftDates(startDate, endDate) {
    return this.get(startDate, endDate).then(shifts => {
      return shifts.map(shift => shift.start_time);
    });
  },

  async getThisMonthsHours() {
    const userIdToken = await firebase.auth().currentUser.getIdToken(true);
    const endpoint = "/api/cam/hours";

    return new Promise((resolve, reject) => {
      axios.get(endpoint, { headers: { "Authorization": userIdToken } })
        .then(response => resolve(response.data.hours))
        .catch(reason => reject(new Error("Cam Hours API Error. " + reason.message)));
    });
  },

  async getUnavailability() {
    const userIdToken = await firebase.auth().currentUser.getIdToken(true);
    const endpoint = "/api/unavailability";

    return new Promise((resolve, reject) => {
      axios.get(endpoint, { headers: { "Authorization": userIdToken } })
        .then(response => resolve(response.data))
        .catch(reason => reject(new Error("Shift Unavailability API Error. " + reason.message)));
    });
  },

  async setUnavailability(date) {
    const userIdToken = await firebase.auth().currentUser.getIdToken(true);
    const endpoint = "/api/unavailability/set/date";

    return new Promise((resolve, reject) => {
      axios.post(endpoint, { date: date }, { headers: { "Authorization": userIdToken } })
        .then(response => resolve(response.data))
        .catch(reason => reject(new Error("Shift Set Unavailability API Error. " + reason.message)));
    });
  },

  async unsetUnavailability(date) {
    const userIdToken = await firebase.auth().currentUser.getIdToken(true);
    const endpoint = "/api/unavailability/unset/date";

    return new Promise((resolve, reject) => {
      axios.post(endpoint, { date: date }, { headers: { "Authorization": userIdToken } })
        .then(response => resolve(response.data))
        .catch(reason => reject(new Error("Shift Unset Unavailability API Error. " + reason.message)));
    });
  }
};

export default shiftsApiService;
